export const RAW_FORM_OPTIONS = {
  body_parts: [{
      key: "is_multiple",
      value: true,
    },
    {
      key: "filter_by_body_systems",
      value: "",
    },
  ],
  textinput: [{
    key: "is_required",
    value: true,
  }, ],
  textarea: [{
    key: "is_required",
    value: true,
  }, ],
  numberinput: [{
      key: "min",
      value: "0",
    },
    {
      key: "max",
      value: "100",
    },
    {
      key: "step",
      value: "1",
    },
    {
      key: "prefix",
      value: "",
    },
    {
      key: "suffix",
      value: "",
    },
  ],
  rangeslider: [{
      key: "min",
      value: "0",
    },
    {
      key: "max",
      value: "100",
    },
    {
      key: "step",
      value: "1",
    },
    {
      key: "prefix",
      value: "",
    },
    {
      key: "suffix",
      value: "",
    },
  ],
  datepicker: [{
      key: "date_format",
      value: "mm/yy",
    },
    {
      key: "min_date",
      value: "",
    },
    {
      key: "max_date",
      value: "",
    },
    {
      key: "range",
      value: false,
    },
  ],
  datetimepicker: [{
      key: "min_date",
      value: "",
    },
    {
      key: "max_date",
      value: "",
    },
  ]
}